import PropTypes from "prop-types";

const CircularProgress = ({
  percentage = 0,
  size = 100,
  strokeWidth = 8,
  color = "text-empower-500",
  backgroundColor = "text-gray-200",
  className = "",
  showPercentage = true,
  fontSize = 48,
}) => {
  // Ensure percentage is between 0 and 100
  const normalizedPercentage = Math.min(100, Math.max(0, percentage));

  // Calculate radius and circumference
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalizedPercentage / 100) * circumference;

  // Center of the circle
  const center = size / 2;

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
        style={{ position: "absolute" }}
      >
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          className={backgroundColor}
        />
        {/* Progress circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={`${color} transition-all duration-300 ease-in-out`}
        />
      </svg>
      {/* Percentage text */}
      {showPercentage && (
        <span
          className={`font-semibold ${color} z-10`}
          style={{ fontSize: fontSize }}
        >
          {Math.round(normalizedPercentage)}%
        </span>
      )}
    </div>
  );
};

CircularProgress.propTypes = {
  percentage: PropTypes.number,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  showPercentage: PropTypes.bool,
  fontSize: PropTypes.number,
};

export default CircularProgress;
